import { log, logError } from '../../utils/logging';

/* global Word */

/**
 * Word JavaScript API uses changeTrackingMode (WordApi 1.4), not trackRevisions.
 * Values: Word.ChangeTrackingMode.trackAll | trackMineOnly | off
 */
export class TrackChangesManager {
  /**
   * Checks if Track Changes is currently enabled (changeTrackingMode is trackAll or trackMineOnly).
   */
  static async isTrackChangesEnabled(): Promise<boolean> {
    try {
      return await Word.run(async (context) => {
        const doc = context.document;
        doc.load('changeTrackingMode');
        await context.sync();
        const mode = (doc as any).changeTrackingMode;
        return mode === 'TrackAll' || mode === 'TrackMineOnly';
      });
    } catch (error) {
      logError('Failed to check Track Changes status', error);
      return false;
    }
  }
  
  /**
   * Enables Track Changes if not already enabled (sets changeTrackingMode to TrackAll).
   * Requires WordApi 1.4; ensure manifest has Requirements WordApi 1.4.
   */
  static async ensureEnabled(): Promise<boolean> {
    try {
      const isEnabled = await this.isTrackChangesEnabled();
      if (isEnabled) {
        log('Track Changes already enabled');
        return true;
      }

      return await Word.run(async (context) => {
        const doc = context.document;
        (doc as any).changeTrackingMode = 'TrackAll';
        await context.sync();
        log('Track Changes enabled (changeTrackingMode = TrackAll)');
        return true;
      });
    } catch (error) {
      logError('Failed to enable Track Changes', error);
      return false;
    }
  }

  /**
   * Disables Track Changes (sets changeTrackingMode to Off).
   */
  static async disable(): Promise<void> {
    try {
      await Word.run(async (context) => {
        (context.document as any).changeTrackingMode = 'Off';
        await context.sync();
        log('Track Changes disabled');
      });
    } catch (error) {
      logError('Failed to disable Track Changes', error);
      throw error;
    }
  }
}

